import { createApiCall } from "services/api/createApiCall";

export const getCurrenciesAPI = async () => {
  const response = await createApiCall({
    path: "/v1/lookup/currencies",
    method: "GET",
  })();

  return response.data;
};
